import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SrExpSubexpAuthService {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {

    if ((localStorage.getItem('userType') === '2') &&
      ((localStorage.getItem('roleId') === '5') || (localStorage.getItem('roleId') === '6')
      || (localStorage.getItem('roleId') === '7') || (localStorage.getItem('roleId') === '8'))) {
      return true;
    } else {
      this.router.navigate(['/userview/dashboard']);
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/AUTHGAURD/sr-exp-subexp-auth.service.ts